import type { ComponentsArticleReasonsWhy } from 'queries/graphql';

import { ReasonWhy } from './components/ReasonWhy';

import styles from './styles.module.sass';

export default function ReasonsWhy({ sectionId, reasons = [] }: ComponentsArticleReasonsWhy) {
  return (
    <div id={sectionId} className={styles.column}>
      {reasons.map(reason => (
        <ReasonWhy key={reason.id} {...reason} />
      ))}
    </div>
  );
}
